import { loadUserFromStorage } from '../authStorage';
import { resolveDateFormat, type DateFormatOrder, type DateFormatPreference } from './preferences';
import type { DateFormatPrefs } from './format';

/** Non-hook read for modules that cannot use hooks (formatters in utils). */
export function getDatePreferencesSnapshot(): DateFormatPrefs & { order: DateFormatOrder } {
    let uiLanguage = 'en-US';
    let dateFormat: DateFormatPreference = null;
    try {
        const d = loadUserFromStorage();
        const u = d?.user as
            | {
                  uiLanguage?: string;
                  dateFormat?: unknown;
                  entity?: { defaultLanguage?: string };
              }
            | undefined;
        uiLanguage =
            String(u?.uiLanguage || u?.entity?.defaultLanguage || 'en-US').trim() || 'en-US';
        const raw = u?.dateFormat;
        if (raw === 'MDY' || raw === 'DMY' || raw === 'YMD') dateFormat = raw;
    } catch {
        /* ignore */
    }
    return {
        uiLanguage,
        dateFormat,
        order: resolveDateFormat(uiLanguage, dateFormat),
    };
}
